export default [
  {
    path: '',
    name: 'admin',
    component: () => import(/* webpackChunkName: "home" */ '../views/admin/Home.vue')
  },
  {
    path: 'orders',
    component: () => import(/* webpackChunkName: "orders" */ '../views/admin/Orders.vue'),
    children: [
      {
        path: '',
        name: 'admin.orders',
        component: () => import(/* webpackChunkName: "orders" */ '../views/admin/orders/Index.vue')
      },
      {
        path: ':id',
        name: 'admin.orders.show',
        component: () => import(/* webpackChunkName: "orders.show" */ '../views/admin/orders/Show.vue')
      },
    ]
  },
  {
    path: 'categories',
    component: () => import(/* webpackChunkName: "categories" */ '../views/admin/Categories.vue'),
    children: [
      {
        path: '',
        name: 'admin.categories',
        component: () => import(/* webpackChunkName: "categories" */ '../views/admin/categories/Index.vue')
      },
    ]
  },
  {
    path: 'qualities',
    component: () => import(/* webpackChunkName: "qualities" */ '../views/admin/Qualities.vue'),
    children: [
      {
        path: '',
        name: 'admin.qualities',
        component: () => import(/* webpackChunkName: "qualities" */ '../views/admin/qualities/Index.vue')
      },
    ]
  },
  {
    path: 'types',
    component: () => import(/* webpackChunkName: "types" */ '../views/admin/Types.vue'),
    children: [
      {
        path: '',
        name: 'admin.types',
        component: () => import(/* webpackChunkName: "types" */ '../views/admin/types/Index.vue')
      },
      {
        path: 'create',
        name: 'admin.types.create',
        component: () => import(/* webpackChunkName: "types" */ '../views/admin/types/Create.vue')
      },
      {
        path: ':id',
        name: 'admin.types.show',
        component: () => import(/* webpackChunkName: "types" */ '../views/admin/types/Show.vue')
      },
      {
        path: ':id/edit',
        name: 'admin.types.edit',
        component: () => import(/* webpackChunkName: "types" */ '../views/admin/types/Edit.vue')
      },
    ]
  },
  {
    path: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/admin/Users.vue'),
    children: [
      {
        path: '',
        name: 'admin.users',
        component: () => import(/* webpackChunkName: "users" */ '../views/admin/users/Index.vue')
      },
      {
        path: 'create',
        name: 'admin.users.create',
        component: () => import(/* webpackChunkName: "users" */ '../views/admin/users/Create.vue')
      },
      {
        path: ':id',
        name: 'admin.users.show',
        component: () => import(/* webpackChunkName: "users" */ '../views/admin/users/Show.vue')
      },
    ]
  },
  {
    path: 'notifications',
    name: 'admin.notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/dashboard/Notifications.vue')
  },
  {
    path: 'messages',
    component: () => import(/* webpackChunkName: "messages" */ '../views/dashboard/Messages.vue'),
    children: [
      {
        path: '',
        name: 'admin.messages',
        component: () => import(/* webpackChunkName: "messages" */ '../views/dashboard/messages/Index.vue')
      },
      {
        path: ':id',
        name: 'admin.messages.show',
        component: () => import(/* webpackChunkName: "messages.show" */ '../views/dashboard/messages/Show.vue')
      },
    ]
  },
  {
    path: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/dashboard/Profile.vue'),
    children: [
      {
        path: '',
        name: 'admin.profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/dashboard/profile/Index.vue')
      },
    ]
  },
]